import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import retrexlogo from 'assets/icons/retrexlogo.png';
import successgif from 'assets/gifs/successgif.gif';
import { getApiCall, postApiCall } from 'api/apiService';
import { AGENT_GETQUESTION, AGENT_SAVEQUESTION } from 'constant/app.config';
import {
  Bedrooms,
  Floorplan,
  Garden,
  Location,
  Locationwhite,
  NaturalLightIcon,
  OverAllIcon,
  SelectIcon,
  NoneIcon,
} from './Icons';
import {
  ChatLoading,
  PriceBracketChat,
  PropertyWorthChat,
} from './ChatComponent';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Loading from 'assets/images/loading.png';

// chat question component
const ChatQuestion = ({ question }) => {
  const only450screen = useMediaQuery((theme) => theme.breakpoints.down(450));

  return (
    <Stack
      direction={'row'}
      justifyContent={'center'}
      alignItems={'flex-end'}
      gap={'20px'}
      minWidth="45%"
      maxWidth="90%"
    >
      <Box
        sx={{
          background: 'rgba(0, 101, 252, 1)',
          width: '90%',
          borderRadius: '50px',
          zIndex: '100',
        }}
      >
        <Typography
          component={'p'}
          sx={{
            color: 'white',
            fontSize: { xs: '13px', sm: '15px', md: '20px' },
            fontFamily: 'Poppins',
            fontWeight: '400',
            textAlign: 'left',
            padding: '20px',
          }}
        >
          {question}
        </Typography>
      </Box>
      <Box
        sx={{
          height: only450screen ? '40px' : '56px',
          width: only450screen ? '40px' : '56px',
          background: 'white',
          borderRadius: '50%',
          bottom: '-30px',
          right: '-30px',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 2px 6px rgba(0,0,0,0.12)', // 👈 light shadow
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins',
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
          }}
        >
          <img
            alt="Logo"
            src={Loading}
            style={{ height: '40px', width: '40px' }}
          />
        </Typography>
      </Box>
    </Stack>
  );
};

const ChatOptions = ({ question, handleInputChange }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const options1 = [
    { label: 'Bedroom', icon: Bedrooms },
    { label: 'Bathroom', icon: Floorplan },
    { label: 'Garage', icon: OverAllIcon },
    { label: 'Location', icon: Location },
    { label: 'Window covering', icon: Garden },
    { label: 'Swimming Pool', icon: NaturalLightIcon },
  ];

  const options2 = [
    { label: 'Bedroom', icon: Bedrooms },
    { label: 'Bathroom', icon: Floorplan },
    { label: 'Garage', icon: OverAllIcon },
    { label: 'Location', icon: Location },
    { label: 'Window covering', icon: Garden },
    { label: 'Swimming Pool', icon: NaturalLightIcon },
    { label: 'Others', icon: OverAllIcon },
  ];

  const options2WithNone = [
    { label: 'Bedroom', icon: Bedrooms },
    { label: 'Bathroom', icon: Floorplan },
    { label: 'Garage', icon: OverAllIcon },
    { label: 'Location', icon: Location },
    { label: 'Window covering', icon: Garden },
    { label: 'Swimming Pool', icon: NaturalLightIcon },
    { label: 'Others', icon: OverAllIcon },
    { label: 'None', icon: NoneIcon },
  ];

  const options3 = [
    { label: 'Occupy', icon: Floorplan },
    { label: 'Investor', icon: Location },
    { label: 'UpSize', icon: Garden },
    { label: 'DownSize', icon: NaturalLightIcon },
  ];

  useEffect(() => {
    // AQ005 gets None icon, AQ004 does not
    if (question?.questionCode == 'AQ005') {
      setOptions(options2WithNone);
    } else {
      setOptions(
        question?.questionCode == 'AQ002'
          ? options1
          : question?.questionCode == 'AQ004' ||
            question?.questionCode == 'AQ005'
          ? options2
          : question?.questionCode == 'AQ006'
          ? options3
          : []
      );
    }
  }, [question]);

  return (
    <Box
      sx={{
        width: { xs: 'auto', sm: '300px', md: '500px' },
        mt: !matchessm && '50px',
      }}
    >
      {question?.questionCode === 'AQ004' ||
      question?.questionCode === 'AQ005' ? (
        <></>
      ) : (
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: matchessm ? '12px' : '18px',
            fontWeight: '300',
            textAlign: 'center',
            display: 'block',
            p: '20px 0px',
          }}
        >
          Please select
        </Typography>
      )}
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
        md={12}
      >
        {options?.map((item, index) => {
          const IconComponent = item?.icon;
          return (
            <Grid
              key={index}
              item
              md={4}
              sm={4}
              xs={4}
              sx={{ textAlign: 'center' }}
            >
              <IconButton
                disableTouchRipple
                disableFocusRipple
                disableRipple
                onClick={() => {
                  if (
                    question?.questionCode === 'AQ004' ||
                    question?.questionCode === 'AQ005'
                  ) {
                    handleInputChange(item?.label, true);
                  } else {
                    handleInputChange(item?.label);
                  }
                }}
                sx={{ position: 'relative' }}
              >
                <Stack
                  direction={'column'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  sx={{
                    width: onlySmallScreen ? '75px' : '150px',
                    height: !matchessm && '95px',
                  }}
                >
                  <IconComponent
                    value={question?.questionAnswer?.includes(item?.label)}
                  />
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: matchessm ? '12px' : '15px',
                      fontWeight: '300',
                      textAlign: 'center',
                    }}
                  >
                    {item.label}
                  </Typography>
                </Stack>
                {question?.questionAnswer?.includes(item?.label) && (
                  <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                    <SelectIcon />
                  </Box>
                )}
              </IconButton>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const AgentChat = () => {
  const history = useHistory();
  // final thanks Screen trigger
  const [finalTrigger, setFinalTrigger] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [address, setAddress] = useState('');
  const [propertyId, setPropertyId] = useState('');
  const [priceRange, setPriceRange] = useState('');

  // chat loading
  const [loading, setLoading] = React.useState(false);
  const [finalloading, setFinalLoading] = React.useState(false);

  //   current question validations
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('questions'))?.questions ?? {};
    const address =
      JSON.parse(localStorage.getItem('questions'))?.address ?? {};
    const propertyId =
      JSON.parse(localStorage.getItem('questions'))?.propertyId ?? {};
    const priceRange =
      JSON.parse(localStorage.getItem('questions'))?.priceRange ?? null;
    if (data && data?.length) {
      setCurrentQuestionIndex(0);
      setQuestionData(data);
      setAddress(address);
      setPropertyId(propertyId);
      setPriceRange(priceRange);
    }
  }, []);

  const normalizeRangePayload = (value) => {
    if (typeof value !== 'string') return value;
    if (!value.includes('-')) return value;

    const [min, max] = value.split('-');

    const toPlain = (v) =>
      String(v).includes('e') ? Math.trunc(Number(v)).toString() : v;

    return `${toPlain(min)}-${toPlain(max)}`;
  };

  const handleChatReview = () => {
    if (currentQuestionIndex == questionData?.length - 1) {
      setFinalLoading(true);
    }
    const agentQuestionsData = {
      agentQuestionData: [
        {
          questionId: questionData[currentQuestionIndex]?.questionId,
          questionCode: questionData[currentQuestionIndex]?.questionCode,
          questionValue: questionData[currentQuestionIndex]?.questionValue,
          questionAnswer: normalizeRangePayload(
            questionData[currentQuestionIndex]?.questionAnswer
          ),

          questionIsSkiped: questionData[currentQuestionIndex]?.questionAnswer
            ? 0
            : 1,
          propertyId: propertyId,
        },
      ],
    };
    if (currentQuestionIndex != questionData?.length - 1) {
      setLoading(true);
    }
    postApiCall(AGENT_SAVEQUESTION, agentQuestionsData)
      .then((res) => {
        if (currentQuestionIndex == questionData?.length - 1) {
          setCurrentQuestionIndex(null);
          setFinalTrigger(true);
          setFinalLoading(false);
          setTimeout(() => {
            history.replace({
              pathname: `/dashboard/view-dashboard/${propertyId}`,
            });
          }, 2000);
        } else {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
          setLoading(false);
        }
        getApiCall(`${AGENT_GETQUESTION}/${propertyId}`).then((res) => {
          const result = res?.data?.agentQuestions.filter(
            (value) => value.questionAnswer == ''
          );
          const questionsData = {
            priceRange: res?.data?.priceRange,
            propertyId: propertyId,
            address: address || '',
            questions: result,
          };

          localStorage.setItem('questions', JSON.stringify(questionsData));
        });
      })
      .finally(() => {});
  };

  const handleNext = () => {
    if (currentQuestionIndex <= questionData?.length - 1) {
      handleChatReview();
    } else {
      setCurrentQuestionIndex(null);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setFinalTrigger(true);
      }, 2000);
    }
  };

  const handleMultiSelectInputChange = (value) => {
    const updatedQuestions = [...questionData];
    if (!updatedQuestions[currentQuestionIndex]) return;

    const currentAnswers =
      updatedQuestions[currentQuestionIndex].questionAnswer || [];

    let updatedAnswers = [];
    if (value === 'None') {
      updatedAnswers = ['None'];
    } else {
      const filteredAnswers = currentAnswers.filter((item) => item !== 'None');

      if (filteredAnswers.includes(value)) {
        updatedAnswers = filteredAnswers.filter((item) => item !== value);
      } else {
        updatedAnswers = [...filteredAnswers, value];
      }
    }

    updatedQuestions[currentQuestionIndex].questionAnswer = updatedAnswers;

    setQuestionData(updatedQuestions);
  };

  const handleInputChange = (value, isMulti = false) => {
    if (isMulti) {
      handleMultiSelectInputChange(value);
      return;
    }
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      updatedQuestions[currentQuestionIndex].questionAnswer = value;
    }
    setQuestionData(updatedQuestions);
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#fff',
        }}
      >
        {' '}
        <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              mt: matchessm ? '0px' : '20px',
            }}
          >
            <Locationwhite />
            <Typography
              style={{
                color: 'rgba(30, 30, 30, 1)',
                fontFamily: 'Poppins',
                fontWeight: '600',
              }}
              sx={{
                fontSize: {
                  xs: '16px',
                  sm: '20px',
                  md: '24px',
                  lg: '26px',
                  xl: '30px',
                },
              }}
            >
              {address ?? ''}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            mt: matchessm ? '5px' : '50px',
            padding: '5px',
            height: matchessm ? '70%' : finalTrigger ? '100%' : '50%',
          }}
        >
          <Stack
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={matchessm ? '0px' : '25px'}
            marginTop={'20px'}
          >
            <>
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'AQ001' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      width={{ xs: '90%', sm: '40%', md: '40%' }}
                      marginTop={'50px'}
                    >
                      <PriceBracketChat
                        handleInputChange={handleInputChange}
                        value={
                          questionData[currentQuestionIndex]?.questionAnswer ||
                          priceRange
                        }
                      />
                    </Stack>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={handleNext}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        Next
                      </Button>
                    </Stack>
                  </>
                )}
              {!loading &&
                (questionData[currentQuestionIndex]?.questionCode === 'AQ002' ||
                  questionData[currentQuestionIndex]?.questionCode == 'AQ004' ||
                  questionData[currentQuestionIndex]?.questionCode == 'AQ005' ||
                  questionData[currentQuestionIndex]?.questionCode ==
                    'AQ006') && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    {questionData[currentQuestionIndex]?.questionCode ===
                    'AQ002' ? (
                      <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        height={matchessm ? 100 : 200}
                        alignItems={'center'}
                        width={{ xs: '90%', sm: '45%', md: '48%' }}
                        // border={'2px solid blue'}
                      >
                        <PropertyWorthChat
                          handleInputChange={handleInputChange}
                          value={
                            questionData[currentQuestionIndex]
                              ?.questionAnswer != ''
                              ? questionData[currentQuestionIndex]
                                  ?.questionAnswer
                              : priceRange
                          }
                        />
                      </Stack>
                    ) : (
                      <ChatOptions
                        handleInputChange={handleInputChange}
                        question={questionData[currentQuestionIndex]}
                      />
                    )}

                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          finalloading ||
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={() => handleNext()}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        {currentQuestionIndex == questionData?.length - 1
                          ? 'Submit'
                          : 'Next'}
                      </Button>
                      {finalloading && (
                        <img
                          alt="Loader"
                          src={Loading}
                          className="loaderImage"
                          style={{ height: '40px', width: '40px' }} // 🔹 smaller & aligned
                        />
                      )}
                    </Stack>
                  </>
                )}
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'AQ003' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      height={matchessm ? 100 : 200}
                      alignItems={'center'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                    >
                      <PropertyWorthChat
                        handleInputChange={handleInputChange}
                        value={
                          questionData[currentQuestionIndex]?.questionAnswer !=
                          ''
                            ? questionData[currentQuestionIndex]?.questionAnswer
                            : priceRange
                        }
                      />
                    </Stack>

                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={handleNext}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        Next
                      </Button>
                    </Stack>
                  </>
                )}
            </>
            {finalTrigger && (
              <>
                <Box>
                  <Typography
                    style={{
                      color: 'rgb(154, 188, 102)',
                      textAlign: 'center',
                      fontFamily: 'poppins',
                      fontSize: matchessm ? '16px' : '24px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    Your feedback takes us one step nearer to the right sale!{' '}
                  </Typography>
                </Box>

                <img
                  src={successgif}
                  alt="successgif"
                  style={{
                    width: matchessm ? '100%' : '700px',
                  }}
                />
              </>
            )}

            {loading && (
              <ChatLoading value={'AG'} agentProfileImage={Loading} />
            )}
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'absolute',
            bottom: '0px',
          }}
        >
          <Box
            sx={{ padding: '20px', marginBottom: '10px', cursor: 'pointer' }}
            onClick={() => {
              history.goBack();
            }}
          >
            {!finalTrigger && (
              <Typography
                component={'div'}
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: '500',
                  fontSize: matchessm ? '12px' : '20px',
                  color: '#C4C4C4',
                }}
              >
                Go to Dashboard
              </Typography>
            )}
          </Box>
        </DialogActions>
      </Box>
    </>
  );
};

export default AgentChat;
